import { useParams } from 'react-router-dom'
import { useImmediateRequest } from 'app/hooks/useImmediateRequest'

export type SchedulingSmsPolicyLocation = {
  id: string
  name: string
  address?: string
  city?: string
  state?: string
  zip?: string
  supportPhone?: string
}

export type UseSchedulingSmsPolicyReturn = {
  location?: SchedulingSmsPolicyLocation
  loading: boolean
  unavailable: boolean
}

export function useSchedulingSmsPolicy(): UseSchedulingSmsPolicyReturn {
  const { id } = useParams<{ id: string }>()
  const [location, error] = useImmediateRequest<SchedulingSmsPolicyLocation>(
    id ? `/api/scheduling/locations/${id}/sms-policy-info` : ``,
    false,
  )

  return {
    location,
    loading: Boolean(id && !location && !error),
    unavailable: Boolean(!id || error),
  }
}
